import { FC, useEffect } from 'react';
import { IVehicleTile } from '../../../types/vehicleTile';
import ReturnVisitorCarousel from '../../../components/carousels/home-base-hero-carousel/ReturnVisitorCarousel';
import useAppState from '../../../common/state/appState';
import Typography from '@mui/material/Typography';
import { KmxContainer } from '../../../components/KmxContainer';
import Box from '@mui/material/Box';

interface IMiniHomebaseProps {
    viewedVehicleTileList: IVehicleTile[];
    updatedViewedTiles: (vehicleTile: IVehicleTile) => void;
}

export const MiniHomebase: FC<IMiniHomebaseProps> = ({ viewedVehicleTileList, updatedViewedTiles }) => {
    const favoriteVehicles = useAppState((state) => state.favoriteVehicles);
    const fbsData = useAppState((state) => state.fbsData);
    const getFbsDataForStockNumbers = useAppState((state) => state.getFbsDataForStockNumbers);
    const setFavoriteVehicles = useAppState((state) => state.setFavoriteVehicles);

    useEffect(() => {
        setFavoriteVehicles();
    }, []);

    useEffect(() => {
        if (favoriteVehicles.length > 0) {
            getFbsDataForStockNumbers(favoriteVehicles);
        }
    }, [getFbsDataForStockNumbers, favoriteVehicles]);

    return (
        <>
            <KmxContainer maxWidth="xl" sx={{ mt: { xs: 10, sm: 15 }, mb: { xs: 3, sm: 4 } }}>
                <Typography component="h2" sx={{ typography: { xs: 'h5', sm: 'h4' } }}>
                    Pick up where you left off
                </Typography>
            </KmxContainer>
            <Box className="buying-online-mini-homebase" sx={{ '.tns-item': { verticalAlign: 'initial!important' } }}>
                <ReturnVisitorCarousel
                    id="kmx-viewed-carousel"
                    carouselName="mini-homebase"
                    analyticsName="MiniHomebase"
                    isVisible
                    vehicleTileList={viewedVehicleTileList}
                    favoritedStockNumberList={favoriteVehicles}
                    updatedViewedTiles={updatedViewedTiles}
                    enableRemove
                    fbsData={fbsData}
                    onOpenSnackBar={() => {}} // the carousel requires this, but it's actually now handled automatically by the new car tile
                    sectionName="Viewed"
                    ariaLabel="Recently Viewed Cars"
                />
            </Box>
        </>
    );
};
